import { Link } from "react-router-dom";
import { Phone, CalendarCheck, Star, CheckCircle2 } from "lucide-react";
import { BUSINESS } from "@/lib/constants";

export default function About() {
  return (
    <div data-testid="about-page" className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-heading text-4xl sm:text-5xl font-bold text-black text-center">About Us</h1>
      <p className="mt-4 text-xl text-gray-700 text-center max-w-3xl mx-auto">
        For over 11 years, Traffic Tickets Protection INC has helped thousands of
        Albertans protect their licenses, save demerit points, and reduce their fines.
      </p>

      <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <img
          src="https://images.pexels.com/photos/8369211/pexels-photo-8369211.jpeg"
          alt="Our team"
          className="rounded-lg shadow-md w-full"
          style={{ maxHeight: 480, objectFit: "cover" }}
        />
        <div>
          <h2 className="font-heading text-3xl font-semibold text-navy">Our Promise</h2>
          <p className="mt-3 text-lg text-gray-800 leading-relaxed">
            Most traffic tickets we handle get reduced. We talk to you in plain English,
            we explain your options clearly, and we work hard to protect your driving
            record and your insurance rates.
          </p>
          <ul className="mt-6 space-y-3">
            {["11 Years in Business","4.9 Google Rating","Thousands of Drivers Helped","Serving Western Canada","Open Daily 8 AM – 10 PM"].map(t => (
              <li key={t} className="flex items-center gap-3 text-lg">
                <CheckCircle2 className="w-6 h-6 text-gold" /> {t}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 bg-white border-t border-slate-200 pt-12 text-center">
        <div className="flex justify-center gap-1 text-gold mb-3">
          {[1,2,3,4,5].map(i => <Star key={i} className="w-7 h-7 fill-gold text-gold" />)}
        </div>
        <h2 className="font-heading text-3xl font-bold text-black">4.9 Stars on Google</h2>
        <p className="mt-3 text-lg text-gray-700">Real reviews from real Alberta drivers.</p>
        <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
          <Link to="/consultation" className="btn-primary" data-testid="about-consult-btn"><CalendarCheck className="w-5 h-5" /> Book Free Consultation</Link>
          <a href={`tel:${BUSINESS.phoneRaw}`} className="btn-primary" data-testid="about-call-btn">
            <Phone className="w-5 h-5" /> Call {BUSINESS.phone}
          </a>
        </div>
      </div>
    </div>
  );
}
